import { LocaleNumberFormat } from 'models/locale-format';
import { getCurrentLocaleFormat } from './get-locale-format';

export type FormatNumberOptions = {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    format?: LocaleNumberFormat;
};

const numberFormatLocale = (format: LocaleNumberFormat): string => {
    switch (format) {
        case LocaleNumberFormat.ENGLISH:
            return 'en-US';
        case LocaleNumberFormat.EUROPEAN:
            return 'de-DE';
        case LocaleNumberFormat.ISO:
            return 'sv-SE';
        case LocaleNumberFormat.SWISS:
            return 'de-CH';
        case LocaleNumberFormat.INDIAN:
            return 'en-IN';
        default:
            return 'en-US';
    }
};

export const formatNumber = (value: number | null | undefined, options: FormatNumberOptions = {}): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return '';
    const { minimumFractionDigits = 0, maximumFractionDigits = 2 } = options;
    const format = options.format ?? getCurrentLocaleFormat().number;
    const intl = new Intl.NumberFormat(numberFormatLocale(format), {
        minimumFractionDigits,
        maximumFractionDigits,
    });
    let result = intl.format(value);
    if (format === LocaleNumberFormat.SWISS) {
        // de-CH uses U+2019 as the thousands separator; spec calls for an ASCII apostrophe.
        result = result.replace(/’/g, "'");
    }
    return result;
};
